import { CircularProgress, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  root: {
    padding: theme.spacing(3, 2),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
    background: 'transparent'
  },
  spinner: {
    padding: 5,
    textAlign: 'center'
  }
}));

export default function LoadingSpinnerTransparent() {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <CircularProgress className={classes.spinner} />
    </Paper>
  );
}
